<template>
<main-content>
    <kt-panel>
        <kt-panel-body v-if="status !== 'loading'">
            <dedicated-form-editable
                    v-if="form_data.status == statuses.REJECTED"
                    :form_data="form_data"
                    :submit="submitFullForm"
            ></dedicated-form-editable>
            <dedicated-form v-else :form_data="form_data" :submit="submit"></dedicated-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import dedicatedForm from './components/update-form'
import dedicatedFormEditable from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { dedicatedService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import { dedicatedStatus } from '@/constants/dedicatedStatus'

export default {
    components: {
        'main-content': mainContent,
        'dedicated-form': dedicatedForm,
        'dedicated-form-editable': dedicatedFormEditable
    },
    computed: {
        ...mapGetters('dedicated', [
            'form_data', 'status'
        ]),
        form_data: {
            get: function() {
                return this.$store.state.dedicated.form_data
            },
            set: function(value) {
                this.$store.commit('dedicated/setFormData', value)
            }
        }
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            statuses: dedicatedStatus,
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('dedicated/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            let merchant_share_percent = $('#merchant_wage').val()
            let form = $('#dedicated_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    wage: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = {
                merchant_share_percent: merchant_share_percent
            }

            dedicatedService.update(this.hashid, params).then(response => {
                this.$store.commit('dedicated/clearFormData')
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
        submitFullForm(e) {
            this.form_data.merchant_share_percent = $('#merchant_wage').val()
            let form = $('#dedicated_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    merchant_type: {
                        required: true,
                    },
                    birth_crtfct_number: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_serial: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_series_letter: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_series_number: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    gender: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    com_name_fa: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    com_name_en: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    national_legal_code: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_date: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    commercial_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_serial: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_series_letter: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_series_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_gender: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_first_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_last_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_phone_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_telephone_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_email: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    province: {
                        required: true,
                    },
                    city: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    ownership_type: {
                        required: true
                    },
                    rental_contract_number: {
                        required: function(){
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    rental_expiry_date: {
                        required: function(){
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    category_code: {
                        required: true,
                    },
                    sheba_number: {
                        required: true
                    },
                    certificate_number: {
                        required: true
                    },
                    certificate_issue_date: {
                        required: true
                    },
                    certificate_expiry_date: {
                        required: true
                    },
                    website_address: {
                        required: true,
                        url: true
                    },
                    server_ip: {
                        required: true
                    },
                    business_type: {
                        required: true
                    },
                    programming_language: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                    wage: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.form_data
            // return;
            dedicatedService.updateFullForm(this.hashid, params).then(response => {
                this.$store.commit('dedicated/clearFormData')
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>